export default __webpack_public_path__ + "src/appV2/redesign/Workplace/Review/Comment/ExternalReviewBadge/yelpLogo.png";